import { getAssetUrl } from '../../util'
import { getViews } from '../lib/model-util'
import TipModal from './TipModal'
import { createSignal } from 'solid-js'

interface Props {
  id: string
  characterId: string
  modelName: string
  locked?: boolean
  liked?: boolean
  favorited?: boolean
  url?: string
  likes?: number
  favorites?: number
  featured?: boolean
  onImage: (url: string) => void
  onLike: (id: string) => void
  onFavorite: (id: string) => void
}

const ModelPhotoCard = (props: Props) => {
  const [showTipModal, setShowTipModal] = createSignal(false)
  const viewsStartDate: string = '2024-11-01'

  return (
    <>
      <div
        class={`group relative cursor-pointer overflow-hidden rounded-[14px] border border-[rgba(255,255,255,0.06)] transition-all duration-[250ms] hover:-translate-y-[3px] hover:border-[rgba(255,60,172,0.45)] hover:shadow-[0_12px_30px_rgba(138,43,226,0.25)] ${props.featured ? 'col-span-2 sm:row-span-2 sm:self-stretch' : 'self-start'}`}
        style={{ background: '#14102a' }}
      >
        {/* Image */}
        <div
          class={`relative overflow-hidden ${props.locked ? 'blur-lg' : ''} ${props.featured ? 'h-full' : ''}`}
          style={{ 'aspect-ratio': props.featured ? undefined : '3/4' }}
          onClick={() => props.url && props.onImage(props.url)}
        >
          <img
            src={props.url && getAssetUrl(props.url, true)}
            class="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.06]"
          />
          {/* Gradient tint */}
          <div
            class="pointer-events-none absolute inset-0"
            style={{ background: 'linear-gradient(180deg, transparent 50%, rgba(11,8,28,0.92) 100%)' }}
          />
          {/* Ribbon */}
          <span
            class={`absolute z-[2] inline-flex items-center gap-1 rounded-md font-rajdhani font-extrabold uppercase text-white ${props.featured ? 'left-3 top-3 h-[26px] px-2.5 text-[11px] tracking-[1px]' : 'left-2 top-2 h-[22px] px-2 text-[9.5px] tracking-[1.2px]'}`}
            style={{
              background: 'linear-gradient(135deg, #8A2BE2, #FF3CAC)',
              'box-shadow': '0 4px 10px rgba(138,43,226,0.4)',
            }}
          >
            ★ Exclusive
          </span>
          {/* Bottom meta overlay */}
          <div class="absolute bottom-0 left-0 right-0 z-[2] px-2.5 pb-2.5 pt-2">
            <div class="truncate text-[12px] font-bold text-white" style={{ 'text-shadow': '0 1px 6px rgba(0,0,0,0.6)' }}>
              {props.modelName}
            </div>
            <div class={`mt-0.5 flex items-center gap-2.5 font-rajdhani text-[10.5px] font-semibold text-[rgba(255,255,255,0.7)] ${props.locked ? 'blur-sm' : ''}`}>
              <span class="inline-flex items-center gap-1">
                ❤ {props.likes && props.likes > 0 ? props.likes : '0'}
              </span>
              <span>· {getViews(props.id, viewsStartDate)} views</span>
            </div>
          </div>
        </div>
      </div>

      <TipModal
        modelName={props.modelName}
        show={showTipModal()}
        onClose={() => setShowTipModal(false)}
        imageId={props.id}
        characterId={props.characterId}
      />
    </>
  )
}

export default ModelPhotoCard
